import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AverageTicketWidget } from '../../models/loyalty-dashboard.model';

@Component({
  selector: 'app-average-ticket-widget',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="stat-card">
      <span class="stat-card__label">Average ticket</span>
      <ng-container *ngIf="data as widget; else noData">
        <span class="stat-card__value">{{ (widget.member | currency) ?? 'N/A' }}</span>
        <span class="stat-card__detail">
          Members · non-members
          <span class="stat-card__highlight">{{ (widget.nonMember | currency) ?? 'N/A' }}</span>
        </span>
      </ng-container>
      <ng-template #noData>
        <p class="stat-card__empty">No data available.</p>
      </ng-template>
    </div>
  `,
  styleUrl: '../stat-card.scss',
})
export class AverageTicketWidgetComponent {
  @Input() data: AverageTicketWidget | null = null;
}
